module.exports = __webpack_public_path__ + "static/media/pexels-alexy-almond-3756659.27b8026b.jpg";